
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-certified/steps-to-get-certified-canada",
      function () {
        return require("private-next-pages/get-certified/steps-to-get-certified-canada.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-certified/steps-to-get-certified-canada"])
      });
    }
  